import React from "react";
import clsx from "clsx";
import * as Icon from "react-feather";

const CATEGORY_ICONS = {
	bookkeeping: Icon.BookOpen,
	year_end: Icon.BarChart2,
	sred: Icon.Zap,
	tax: Icon.FileText,
	sales_tax: Icon.Percent,
	payroll: Icon.DollarSign,
	client_service: Icon.MessageCircle,
	administration: Icon.Briefcase,
	marketing: Icon.TrendingUp,
	quality: Icon.Award,
	folder: Icon.Folder,
};

const TILE_SIZE_CLASSES = {
	small: "tk-icon-tile--sm",
	medium: "",
	large: "tk-icon-tile--lg",
};

class PlaybookCategoryIcon extends React.PureComponent {
	render() {
		const { icon, size = "medium" } = this.props;
		const CategoryIcon = CATEGORY_ICONS[icon] || Icon.Folder;

		return (
			<span className={clsx("tk-icon-tile", TILE_SIZE_CLASSES[size])}>
				<CategoryIcon />
			</span>
		);
	}
}

export default PlaybookCategoryIcon;
